export const HANDLE_HEIGHT = 140;
export const CONTENT_HEIGHT_FIRST_SNAP = 240;
export const FOOTER_HEIGHT = 100;
